    import React from 'react'
    
    const EditFacilites = () => {
      return (
        <div className="modal fade" id="edit-facilites" tabIndex="-1"  aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">Edit Room Facility</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label className="form-label text-muted">Facility Name</label>
                                <input type="text" className="form-control" defaultValue="Delicious Food"/>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" className="btn btn-primary">Update changes</button>
                    </div>
                </div>
            </div>
        </div>
      )
    }
    
    export default EditFacilites